import clsx from "clsx";

export function CalcResult({
    value,
    showEqualSign = true,
}: {
    value: string | null;
    showEqualSign?: boolean;
}) {
    if (value === null) return null;

    return (
        <div className="mt-2 w-full">
            {showEqualSign && (
                <span className="text-default py-0.5 pr-2">=</span>
            )}
            <span
                className={clsx(
                    "text-default bg-default-overlay-7 rounded-lg border border-slate-700 px-2 py-1",
                )}
            >
                {value}
            </span>
        </div>
    );
}
